import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OzowEftApi } from 'src/app/api/ozow/ozow.api.class';
import {OzowPaymentUpdateRequest} from "../../interfaces/ozow/ozow";

@Injectable({
  providedIn: 'root'
})
export class OzowService {

  constructor(private ozowEftApi: OzowEftApi) {}

  initializePayment(sessionToken: string): Observable<any> {
    return this.ozowEftApi.initializePayment(sessionToken);
  }

  update(sessionToken: string, ozowPaymentUpdateRequest: OzowPaymentUpdateRequest): Observable<object> {
    return this.ozowEftApi.update(sessionToken, ozowPaymentUpdateRequest);
  }

}
